import script from "./AffiliateDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateDashboard.vue?vue&type=style&index=0&id=7837d8a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7837d8a4"]])

export default __exports__